import { Label } from "@/components/ui/label";

export const FormField = ({ id, label, required, error, hint, children }) => (
  <div className="space-y-2">
    <Label htmlFor={id} className="text-sm font-semibold text-slate-800">
      {label}
      {required && <span className="ml-0.5 text-rose-500">*</span>}
    </Label>
    {children}
    {error ? (
      <p className="text-xs font-medium text-rose-600" data-testid={`${id}-error`}>{error}</p>
    ) : hint ? (
      <p className="text-xs text-slate-500">{hint}</p>
    ) : null}
  </div>
);

export const FormSection = ({ step, title, subtitle, children }) => (
  <section className="space-y-5">
    <div className="flex items-start gap-3">
      <span className="mt-1 font-heading text-xs font-extrabold tracking-[0.2em] text-emerald-600">{step}</span>
      <div>
        <h2 className="font-heading text-base font-bold text-slate-900 md:text-lg">{title}</h2>
        {subtitle && <p className="text-sm text-slate-500">{subtitle}</p>}
      </div>
    </div>
    {children}
  </section>
);

export const inputClass = (invalid) =>
  `h-11 rounded-xl border-slate-200 bg-white px-3.5 text-sm transition-colors hover:border-emerald-300 focus-visible:ring-2 focus-visible:ring-emerald-500/30 ${invalid ? "border-rose-400" : ""}`;
